import { Pipe, PipeTransform } from '@angular/core';
import { StrMarker } from './types/strMarker';

@Pipe({
  name: 'mark'
})
export class MarkPipe implements PipeTransform {

  transform(value: string, strMarkers : StrMarker[]): string {
    var retVal = value;
    strMarkers.slice().reverse().forEach(strMarker => {
      var markedValue = retVal.substring(strMarker.startIndex,strMarker.startIndex + strMarker.length);
      markedValue =  `<span class=${strMarker.markerClass}>${markedValue}</span>`;
      retVal = retVal.substring(0,strMarker.startIndex) + markedValue + retVal.substring(strMarker.startIndex + strMarker.length);
    });

    return retVal;
  }
}
